<template>
  <div class="news">
    <div class="page-header">
      <div class="cover">
        <h1 class="has-text-white is-family-secondary">
          News &amp; Updates
        </h1>
      </div>
    </div>
    <div ref="list" class="container section tw-mt-5">
      <div class="section-block">
        <span class="title tw-text-black">
          MUSTARD NEWS &amp; UPDATES
        </span>
      </div>

      <promised :promise="newsPromise" v-slot:combined="{ isPending, data }">
        <skeleton-loading v-if="isPending" class="tw-mt-6 column is-3 tw-p-0" />
        <template v-else-if="data">
          <div class="columns is-multiline tw-mt-4">
            <div class="column is-half">
              <full-calendar
                ref="fullcalendar"
                class="mustard-calendar"
                :options="options"
              />
              <small
                >Timezone:
                {{
                  calendarOptions.timeZone + ' (UTC' + calendar.utcOffset + ')'
                }}</small
              >
            </div>
            <div v-for="news in data.data" :key="news.id" class="column is-3">
              <blog-card :blog="news" redirect-to="news.view" />
            </div>
          </div>

          <b-pagination
            class="tw-mt-8"
            v-if="data.meta.last_page > 1"
            @change="onPageChanged"
            :total="data.meta.total"
            :current.sync="data.meta.current_page"
            :per-page="data.meta.per_page"
            order="is-centered"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
          >
          </b-pagination>
        </template>
      </promised>
    </div>
    <view-calendar-event
      ref="eventView"
      :event="event"
      @closed="resetEventDetails()"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import BlogCard from '@/components/BlogCard'
import Blog from '@/models/Blog'
import * as BlogType from '@/utils/consts/BlogType'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import ViewCalendarEvent from '@/components/modals/ViewCalendarEvent'
import dayjs from 'dayjs'

export default {
  components: {
    BlogCard,
    FullCalendar,
    ViewCalendarEvent
  },
  metaInfo: {
    title: 'News & Updates'
  },
  data() {
    return {
      isLoading: false,
      newsPromise: null,
      news: {
        meta: {
          current_page: 1
        }
      },
      reqPageLimit: 10,
      event: {
        id: null,
        type: ''
      },
      eventsJson: [],
      options: {
        plugins: [dayGridPlugin, interactionPlugin],
        views: {
          dayGrid: {
            dayMaxEventRows: 2
          }
        },
        eventClick: info => {
          this.event.id = parseInt(info.event._def.publicId)
          this.event.type = info.event._def.extendedProps.event_type
          this.$refs.eventView.open()
        }
      }
    }
  },
  async mounted() {
    this.getNews()
    await this.getCalendarMasterEvents().then(async () => {
      this.eventsJson = this.calendarOptions.events
      await this.convertDateTimeToTz()
      this.options.events = this.eventsJson
      this.options = { ...this.calendarOptions, ...this.options }
    })
  },
  computed: {
    ...mapState({
      calendar: state => state.calendar,
      calendarOptions: state => state.calendar.options
    })
  },
  methods: {
    ...mapActions({
      getCalendarMasterEvents: 'getCalendarMasterEvents'
    }),
    getNews() {
      this.newsPromise = Blog.include('created_by', 'cover')
        .where('type', BlogType.NEWS)
        .page(this.news.meta.current_page)
        .limit(this.reqPageLimit)
        .get()
        .catch(() => {
          this.$router.replace({ name: 'home' })
        })
    },
    resetEventDetails() {
      this.event = {
        id: null,
        type: ''
      }
    },
    onPageChanged(page) {
      this.news.meta.current_page = page
      this.getNews()
    },
    convertDateTimeToTz() {
      this.eventsJson.forEach(event => {
        event.extendedProps.event_type === 'master'
          ? (event.color = '#00adcd')
          : ``

        if (event.startRecur) {
          event.startRecur = dayjs(event.startRecur)
            .tz(this.calendarOptions.timeZone)
            .format()
          event.endRecur = dayjs(event.endRecur)
            .tz(this.calendarOptions.timeZone)
            .format()
        } else {
          event.start = dayjs(event.start)
            .tz(this.calendarOptions.timeZone)
            .format()
        }
        if (event.startRecur && event.display === 'block') {
          event.allDay = false
          event.start = dayjs(event.startRecur)
            .tz(this.calendarOptions.timeZone)
            .format()
          event.end = dayjs(event.endRecur)
            .tz(this.calendarOptions.timeZone)
            .format()
          delete event.startRecur
          delete event.endRecur
        }
      })
    }
  }
}
</script>
